"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcFixedAssetRentalCard = class UcFixedAssetRentalCard extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    fixedAsset;
    onFixed_asset(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fixedAsset");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    ux;
    b_2248226175642056_style;
    dataMembers = ['ux', 'b_2248226175642056_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_2248226175642056_style: {
                    minWidth: 0,
                },
            },
        };
    }
    async act_1889980785424776_emit_6352_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1889980785424776_close_6351_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_1889980785424776_showModal_6350_getActionArgs($event) {
        return {
            name: "AddFixedAssetToRentalModal",
            props: {
                asset: this.fixedAsset,
            },
        };
    }
    async evh_1889980785424776_clickPreventStop(event, scope) {
        return await this.actions.evh_1889980785424776_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1889980785424776_emit_6352 = new core_1.actions.EmitAction({
            actionArgs: this.act_1889980785424776_emit_6352_getActionArgs,
            events: [],
        });
        const evh_1889980785424776_close_6351 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_emit_6352,
            event: "close",
            when: this.evh_1889980785424776_close_6351_getWhen,
            displayName: "emit",
        });
        const act_1889980785424776_showModal_6350 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1889980785424776_showModal_6350_getActionArgs,
            events: [evh_1889980785424776_close_6351],
        });
        const evh_1889980785424776_clickPreventStop_6349 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_showModal_6350,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_1889980785424776_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1889980785424776_clickPreventStop_6349],
        });
        return {
            act_1889980785424776_emit_6352,
            evh_1889980785424776_close_6351,
            act_1889980785424776_showModal_6350,
            evh_1889980785424776_clickPreventStop_6349,
            evh_1889980785424776_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcFixedAssetRentalCard.prototype, "fixedAsset", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fixedAsset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFixedAssetRentalCard.prototype, "onFixed_asset", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcFixedAssetRentalCard.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFixedAssetRentalCard.prototype, "onReadonly", null);
UcFixedAssetRentalCard = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcFixedAssetRentalCard);
exports.default = UcFixedAssetRentalCard;
vue_property_decorator_1.Vue.component("UcFixedAssetRentalCard", UcFixedAssetRentalCard);
